import React, { createContext, useContext, useState, useCallback } from 'react';
import { CheckCircle, XCircle, AlertCircle, X } from 'lucide-react';

const ToastContext = createContext(null);
export const useToast = () => useContext(ToastContext);

let id = 0;

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const add = useCallback((message, type = 'success') => {
    const tid = ++id;
    setToasts(t => [...t, { id: tid, message, type }]);
    setTimeout(() => setToasts(t => t.filter(x => x.id !== tid)), 3500);
  }, []);

  const remove = (tid) => setToasts(t => t.filter(x => x.id !== tid));

  const icons = { success: <CheckCircle size={16} />, error: <XCircle size={16} />, warning: <AlertCircle size={16} /> };
  const colors = { success: '#34C759', error: '#FF3B30', warning: '#FF9500' };

  return (
    <ToastContext.Provider value={add}>
      {children}
      <div style={{ position: 'fixed', bottom: 24, right: 24, zIndex: 9999, display: 'flex', flexDirection: 'column', gap: 8 }}>
        {toasts.map(t => (
          <div key={t.id} style={{
            display: 'flex', alignItems: 'center', gap: 10,
            background: '#1A1A2E', color: '#fff', padding: '12px 16px',
            borderRadius: 10, boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
            minWidth: 280, maxWidth: 380, fontSize: 13,
            borderLeft: `4px solid ${colors[t.type]}`,
            animation: 'slideIn 0.25s ease',
          }}>
            <span style={{ color: colors[t.type], flexShrink: 0 }}>{icons[t.type]}</span>
            <span style={{ flex: 1 }}>{t.message}</span>
            <button onClick={() => remove(t.id)} style={{ background: 'none', border: 'none', color: '#9CA3AF', cursor: 'pointer', display: 'flex' }}>
              <X size={14} />
            </button>
          </div>
        ))}
      </div>
      <style>{`@keyframes slideIn { from { opacity:0; transform:translateX(20px); } to { opacity:1; transform:translateX(0); } }`}</style>
    </ToastContext.Provider>
  );
}
